import { BaseSubChain } from 'domain/entities/monomer-chains/BaseSubChain';

export class PeptideSubChain extends BaseSubChain {}
